"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapeHelper = exports.IsPointInShape = void 0;
/**
 * return value of isPointInShape
 */
var IsPointInShape;
(function (IsPointInShape) {
    IsPointInShape[IsPointInShape["OutsideOfShape"] = -1] = "OutsideOfShape";
    IsPointInShape[IsPointInShape["PartOfShapesContour"] = 0] = "PartOfShapesContour";
    IsPointInShape[IsPointInShape["InsideOfShape"] = 1] = "InsideOfShape";
})(IsPointInShape = exports.IsPointInShape || (exports.IsPointInShape = {}));
/**
 * Helper class that can be used by the individual shape classes to share code.
 */
class ShapeHelper {
    /**
     * Test if a point is inside the given shape.
     * Returns
     * -1 if the point is outside the shape
     * 0 if the point is part of the shape contour
     * 1 if the point is inside the shape
     *
     * @param contour Array of points that describe the shape contour.
     * @param point Point that should be tested.
     */
    static isPointInShape(contour, point) {
        const pointCount = contour.length;
        if (pointCount <= 2) {
            return IsPointInShape.OutsideOfShape;
        }
        // Count the intersections with the contour of a ray starting at the point and going into positive x direction.
        let intersectionCount = 0;
        let c1 = contour[pointCount - 1];
        for (let i = 0; i < pointCount; i++) {
            const c0 = c1;
            c1 = contour[i];
            const px = point[0];
            const py = point[1];
            const c0x = c0[0];
            const c0y = c0[1];
            const c1x = c1[0];
            const c1y = c1[1];
            // If the line segment is completely in the upper or lower or left half space then continue.
            if ((c0y < py && c1y < py) || (c0y > py && c1y > py) || (c0x < px && c1x < px)) {
                continue;
            }
            // Test if the point is part of a horizontal line
            if (c0y === c1y) {
                if (c0x <= px && px <= c1x && py === c0y) {
                    return IsPointInShape.PartOfShapesContour;
                }
                else if (c1x <= px && px <= c0x && py === c0y) {
                    return IsPointInShape.PartOfShapesContour;
                }
                else {
                    continue;
                }
                // Test if the point is on the same height as c0
            }
            else if (py === c0y) {
                if (px === c0x) {
                    return IsPointInShape.PartOfShapesContour;
                }
                else if (px < c0x) {
                    // Only count the intersection in case of p === c1. Otherwise, the intersection will be counted twice.
                    // intersectionCount++;
                    continue;
                }
                else {
                    // (px > c0x)
                    continue;
                }
                // Test if the point is on the same height as c1
            }
            else if (py === c1y) {
                if (px === c1x) {
                    return IsPointInShape.PartOfShapesContour;
                }
                else if (px < c1x) {
                    intersectionCount++;
                    continue;
                }
                else {
                    // (px > c1x)
                    continue;
                }
            }
            // Equation of line segment
            // (x - c0x) * (c1y - c0y) / (c1x - c0x) + c0y = y
            // (x - c0x) / (c1x - c0x) = (y - c0y) / (c1y - c0y)
            // x - c0x = (y - c0y) / (c1y - c0y) * (c1x - c0x)
            // x = (y - c0y) / (c1y - c0y) * (c1x - c0x) + c0x
            // Equation of horizontal line through point
            // py = y
            // Intersection between lines x coordinate
            const ix = ((py - c0y) / (c1y - c0y)) * (c1x - c0x) + c0x;
            const dist = ix - px;
            // If p is part of the line segment return 0.
            if (dist === 0) {
                return IsPointInShape.PartOfShapesContour;
            }
            else if (dist > 0) {
                intersectionCount++;
            }
        }
        const result = intersectionCount % 2 === 0 ? IsPointInShape.OutsideOfShape : IsPointInShape.InsideOfShape;
        return result;
    }
}
exports.ShapeHelper = ShapeHelper;
//# sourceMappingURL=ShapeHelper.js.map